import './contact.scss';
import { findAll, onBlockRender, once } from '../../global/utils/acf-preview';

// The "We respond within 1 business day" note is output after the form (the
// Fluent Forms button help-message doesn't render), so move it into the submit
// row to sit inline beside the Send button, matching Figma.
onBlockRender( 'contact', ( root ) => {
	findAll<HTMLElement>( root, '.contact__form' ).forEach( ( wrap ) => {
		if ( ! once( wrap, 'Contact' ) ) {
			return;
		}
		const note = wrap.querySelector<HTMLElement>( '.contact__form-note' );
		const submit = wrap.querySelector<HTMLElement>( '.ff_submit_btn_wrapper' );
		if ( note && submit ) {
			submit.appendChild( note );
		}
	} );
} );

// ---------------------------------------------------------------------------
// Measurement: announce a successful Fluent Forms submission on the dataLayer
// so Google Tag Manager can fire the GA4 `form_submit` key event (Phase 8).
// Fluent Forms emits both a native CustomEvent and a jQuery event; listen to
// both and de-duplicate per submission.
// ---------------------------------------------------------------------------

type DataLayer = Array<Record<string, unknown>>;

interface FluentDetail {
	form?: HTMLElement | ArrayLike<HTMLElement>;
	response?: { data?: { result?: { message?: string } } };
}

let lastPushed = 0;

function pushFormSubmit( detail: FluentDetail | undefined ): void {
	const now = Date.now();
	if ( now - lastPushed < 1000 ) {
		return; // second notification for the same submission
	}
	lastPushed = now;

	const raw = detail?.form as ( HTMLElement & ArrayLike<HTMLElement> ) | undefined;
	const form: HTMLElement | undefined = raw && 'length' in raw && typeof raw.length === 'number' ? raw[ 0 ] : raw;
	const formId = form?.getAttribute?.( 'data-form_id' ) || form?.dataset?.form_id || '';
	const formName = form?.closest<HTMLElement>( '.contact' )?.querySelector( 'h1, h2' )?.textContent?.trim() || 'Contact';

	const w = window as unknown as { dataLayer?: DataLayer };
	w.dataLayer = w.dataLayer || [];
	w.dataLayer.push( {
		event: 'form_submit',
		form_id: formId,
		form_name: formName,
		form_provider: 'fluentforms',
	} );
}

document.addEventListener( 'fluentform_submission_success', ( e ) => pushFormSubmit( ( e as CustomEvent<FluentDetail> ).detail ) );
window.addEventListener( 'fluentform_submission_success', ( e ) => pushFormSubmit( ( e as CustomEvent<FluentDetail> ).detail ) );

const jq = ( window as unknown as { jQuery?: ( el: unknown ) => { on: ( ev: string, cb: ( e: unknown, form: unknown ) => void ) => void } } ).jQuery;
if ( jq ) {
	jq( document.body ).on( 'fluentform_submission_success', ( _e, form ) => pushFormSubmit( { form: form as HTMLElement } ) );
}
